export var ViewPopupLocationType;
(function (ViewPopupLocationType) {
    ViewPopupLocationType[ViewPopupLocationType["Center"] = 0] = "Center";
    ViewPopupLocationType[ViewPopupLocationType["Custom"] = 1] = "Custom";
})(ViewPopupLocationType || (ViewPopupLocationType = {}));
